import React, { useContext } from 'react';
import { BetslipContext } from '../../data/betslip/BetslipConf';
import BetOptionsSection from './BetOptionsSection';
import CouponEvent from './CouponEvent';

export default function SingleBets(props) {
    const betslipContext = useContext(BetslipContext);
    const container = "singlebets";
	let betslipData = betslipContext.getBetslipData();
	const couponKey = props.couponKey;
    const coupon = betslipData.coupons[couponKey];
    let selections = coupon.selections;
    
    // restoring the selections array for the draw
    let restoredSelections = [];
    for (let k in selections) {
    	let selection = selections[k];
    	if (selection.bets.length === 1) {
    		// duplicate object
    		selection = JSON.parse(JSON.stringify(selection));
    		restoredSelections.push(selection);
    	} else {
    		for (let km in selection.bets) {
    			// the same event for each bet. Player could be interested to purchase any single selection he choosed
    			const bet = selection.bets[km];
    			const duplicatedSelection = JSON.parse(JSON.stringify(selection));
    			duplicatedSelection.bets = [];
    			duplicatedSelection.bets.push(bet);
    			restoredSelections.push(duplicatedSelection);
    		}
    	}
    }
    
    return (
        <>
            {betslipContext.betOptionsSectionMustBeShown() ? 
                <BetOptionsSection couponKey={couponKey} />
                :
                <>
                    {restoredSelections.map(function(selection) {
                        // always the first bet is taken: if an event had more than 1 bet, then I will face a duplicated event in the next selection
                        let betKey = `${selection.bets[0].scomSogei}_${selection.bets[0].handicap}-draw-${selection.bets[0].draw}`;
                        let reactKey = `key-bet-event-coupon-${couponKey}-container-${container}-pal-${selection.pal}-avv-${selection.avv}-for-bet-${betKey}`;
                        return (
                            <React.Fragment key={reactKey}>
                                <CouponEvent selection={selection} couponKey={couponKey} container={container} />
                            </React.Fragment>
                        );
                    })}
                </>
            }
        </>
    );
}
